<div class="row">
  <div class="col-md-12">
    <app-grid-wrapper #grid [hideLoadingMask]="true" [gridSize]="gridSize">
      <div class="col-xs-3 col-lg-2">
        <app-select
          #transactionTypeList
          [items]="transactionTypeOptions"
          [selected]="changeSelectedTransactionType"
        ></app-select>
      </div>
      <div class="col-xs-4 col-lg-3">
        <button class="btn btn-primary" (click)="addEditClicked()">
          <i class="fa fa-plus"></i> Add
        </button>
        <button class="btn btn-default" (click)="importClicked()">
          <i class="fa fa-plus"></i> Import
        </button>
      </div>
    </app-grid-wrapper>
  </div>
</div>
